import { render, staticRenderFns } from "./ProcessedDocsFilter.vue?vue&type=template&id=1b1d5166"
import script from "./ProcessedDocsFilter.vue?vue&type=script&lang=js"
export * from "./ProcessedDocsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports